module.exports = __webpack_public_path__ + "img/quote-right.6a6677d2.svg";